import * as R from "ramda";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { actions, getters } from "../../store";

const mapDispatchToProps = (dispatch) => ({
  listDashboards: () => dispatch(actions.platformReporting.listDashboards()),
  getEmbedUrl: (dashboardId) =>
    dispatch(
      actions.platformReporting.getEmbedUrl({ dashboardIds: [dashboardId] })
    ),
  reset: () => dispatch(actions.platformReporting.reset()),
});

const mapStateToProps = (state) => ({
  dashboards: getters.platformReporting.dashboards(state) || [],
  selectedDashboardId: getters.platformReporting.selectedDashboardId(state),
  embed: getters.platformReporting.embed(state),
  loadingDashboards: getters.platformReporting.loadingDashboards(state),
  loadingEmbed: getters.platformReporting.loadingEmbed(state),
  error: getters.platformReporting.error(state),
});

export default R.compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
);
